export default __webpack_public_path__ + "static/media/product_01.3.3ca2e975.jpg";